import { UPDATE_COMPANY_ADDRESSES_MUTATION } from "@/apis/gql/apolloClient";
import { useMutation } from "@apollo/client";

export const useUpdateCompanyAddresses = () => {
  const [updateCompanyAddresses] = useMutation(
    UPDATE_COMPANY_ADDRESSES_MUTATION,
  );

  return { updateCompanyAddresses };
};
